<button rippleOnHover mat-icon-button color="primary" (click)="back.emit()">
  <mat-icon>arrow_back</mat-icon>
</button>
<div><ng-content></ng-content></div>
